import { ResendOtpOption } from '../ResendOtpOption';

export interface ImageVM {
  path: string;
  altText: string;
}

export interface AuthFieldVM {
  placeholder: string;
  errorText?: string;
  icon: ImageVM;
}

export interface LoginModalVM {
  title: string;
  description: string;
  submitCta: string;
  agreementPolicy: string;
  banner: ImageVM;
  mobileBanner: ImageVM;
  phoneField: AuthFieldVM;
}

export interface SignupModalVM {
  title: string;
  description: string;
  checkboxText: string;
  submitCta: string;
  agreementPolicy: string;
  banner: ImageVM;
  mobileBanner: ImageVM;
  nameField: AuthFieldVM;
  phoneField: AuthFieldVM;
  emailField: AuthFieldVM;
}

export interface OtpModalVM {
  title: string;
  otpSentMessage: string;
  otpSentMessageMobile: string;
  changeMobile: string;
  errorMessage: string;
  tooManyAttempts: string;
  notReceivedText: string;
  resendText: string;
  resendInText: string;
  invalidOtp: string;
  cta: string;
}

export interface ResendOptionVM {
  value: ResendOtpOption;
  text: string;
  subText: string;
  icon: ImageVM;
}

export interface ResendOptionsModalVM {
  title: string;
  confirmCta: string;
  options: ResendOptionVM[];
}

export interface AuthContentVM {
  loginModal: LoginModalVM;
  signupModal: SignupModalVM;
  otpModal: OtpModalVM;
  resendOptionsModal: ResendOptionsModalVM;
  backIcon: ImageVM;
  closeIcon: ImageVM;
}

export const EMPTY_IMAGE: ImageVM = { path: '', altText: '' };
